<script lang="ts">import { cfgToThemeCdnPath } from "@infinitro/config";
import { t, Verbiage } from "@infinitro/content";
import { GradientText, Text } from "@infinitro/text";
import VipTitle from "./vip-title.svelte";
export let steps = [
	{
		titleKey: "sign_up_claim",
		descriptionKey: "sign_up_claim_description"
	},
	{
		titleKey: "cash_or_crypto",
		descriptionKey: "cash_or_crypto_description"
	},
	{
		titleKey: "play_enjoy",
		descriptionKey: "play_enjoy_description"
	},
	{
		titleKey: "get_rewarded",
		descriptionKey: "get_rewarded_description"
	}
];
export let className = "";
export let columnsDesktop = 4;
const getImgSrc = (step, index) => step.imageSrc ?? cfgToThemeCdnPath(`/about-vip/step-${index + 1}.png`);
</script>

<div class="vip-steps-container">
	<VipTitle title={$t(Verbiage.getting_started)} />
	<div class={`vip-steps ${className}`}>
		{#each steps as step, i (i)}
			<div class="vip-step">
				<img
					class="vip-step__image"
					src={getImgSrc(step, i)}
					alt={step.imageAlt ?? $t(Verbiage[step.titleKey])}
				/>

				<Text type="subtitle" subtitleSize="large" subtitleWeight="semibold" textAlign="center"
					>{$t(Verbiage[step.titleKey])}</Text
				>

				<Text
					type="body"
					bodySize="small"
					bodyWeight="regular"
					textColor="gray"
					textAlign="center"
					customStyle="max-width: 250px;"
				>
					{$t(Verbiage[step.descriptionKey])}
				</Text>
			</div>
		{/each}
	</div>
</div>

<style>
	.vip-steps-container {

		display: flex;

		flex-direction: column;

		align-items: center;

		gap: 2rem
}

	.vip-steps {

		display: grid;

		width: 100%;

		gap: 1.5rem;

		grid-template-columns: repeat(1, minmax(0, 1fr))
}

	@media (min-width: 640px) {
		.vip-steps {

				grid-template-columns: repeat(2, minmax(0, 1fr))
		}
	}

	/* Desktop: podés elegir 2/3/4 columnas con una clase en el padre si querés.
	   Si preferís “prop real” sin clase, decime y lo hacemos con style + CSS vars. */
	@media (min-width: 1024px) {
		.vip-steps {

				grid-template-columns: repeat(4, minmax(0, 1fr))
		}
		.vip-steps.cols-2 {

				grid-template-columns: repeat(2, minmax(0, 1fr))
		}
		.vip-steps.cols-3 {

				grid-template-columns: repeat(3, minmax(0, 1fr))
		}
		.vip-steps.cols-4 {

				grid-template-columns: repeat(4, minmax(0, 1fr))
		}
	}

	.vip-step {

		display: flex;

		flex-direction: column;

		align-items: center;

		gap: 0.5rem;

		text-align: center;

		padding-left: 0.5rem;

		padding-right: 0.5rem
}

	.vip-step__image {

		margin-bottom: 1rem;

		height: 180px;

		width: auto;

		pointer-events: none;

		-webkit-user-select: none;

		   -moz-user-select: none;

		        user-select: none
}

	@media (min-width: 768px) {
		.vip-step__image {

				height: 220px;

				width: auto
		}
	}
</style>
